var map = {
	"./taro-audio-core.entry.js": [
		885628,
		5628
	],
	"./taro-block-core.entry.js": [
		548243,
		8243
	],
	"./taro-button-core.entry.js": [
		898679,
		8679
	],
	"./taro-camera-core.entry.js": [
		403109,
		3109
	],
	"./taro-canvas-core.entry.js": [
		199209,
		9209
	],
	"./taro-checkbox-core_2.entry.js": [
		96400,
		6400
	],
	"./taro-cover-image-core.entry.js": [
		363502,
		3502
	],
	"./taro-cover-view-core.entry.js": [
		569813,
		9813
	],
	"./taro-custom-wrapper-core.entry.js": [
		385303,
		5303
	],
	"./taro-form-core.entry.js": [
		750915,
		915
	],
	"./taro-icon-core.entry.js": [
		52351,
		2351
	],
	"./taro-image-core.entry.js": [
		392593,
		2593
	],
	"./taro-input-core.entry.js": [
		700075,
		75
	],
	"./taro-label-core.entry.js": [
		458126,
		8126
	],
	"./taro-movable-area-core.entry.js": [
		351799,
		1799
	],
	"./taro-movable-view-core.entry.js": [
		213909,
		3909
	],
	"./taro-navigator-core.entry.js": [
		357975,
		7975
	],
	"./taro-open-data-core.entry.js": [
		986495,
		6495
	],
	"./taro-picker-core_2.entry.js": [
		680930,
		930
	],
	"./taro-picker-view-column-core.entry.js": [
		758218,
		8218
	],
	"./taro-picker-view-core.entry.js": [
		111820,
		1820
	],
	"./taro-progress-core.entry.js": [
		47918,
		7918
	],
	"./taro-pull-to-refresh.entry.js": [
		675862,
		5862
	],
	"./taro-radio-core_2.entry.js": [
		873595,
		3595
	],
	"./taro-rich-text-core.entry.js": [
		541428,
		1428
	],
	"./taro-scroll-view-core.entry.js": [
		949319,
		9319
	],
	"./taro-slider-core.entry.js": [
		11192,
		1192
	],
	"./taro-swiper-core_2.entry.js": [
		168818,
		8818
	],
	"./taro-switch-core.entry.js": [
		118843,
		8843
	],
	"./taro-tabbar.entry.js": [
		519843,
		9843
	],
	"./taro-text-core.entry.js": [
		601840,
		1840
	],
	"./taro-textarea-core.entry.js": [
		416192,
		6192
	],
	"./taro-video-control_3.entry.js": [
		434961,
		745
	],
	"./taro-view-core.entry.js": [
		550428,
		428
	],
	"./taro-web-view-core.entry.js": [
		673114,
		3114
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 741274;
module.exports = webpackAsyncContext;